import { getPresentationConfiguration, type GetPresentationConfigurationResponse } from '@/api';

export async function loadPresentationConfiguration(): Promise<GetPresentationConfigurationResponse> {
  const result = await getPresentationConfiguration();
  if (result.response?.ok && result.data) {
    return result.data;
  }

  if (__PRESENTATION_CONFIGURATION__) {
    return __PRESENTATION_CONFIGURATION__;
  }

  throw new Error(`Fetching presentation configuration failed: ${result.error}`);
}
